export function formatINR(amount) {
  try {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(amount);
  } catch (e) {
    return `₹${Math.round(amount).toLocaleString("en-IN")}`;
  }
}

// For PDF, avoid the Unicode rupee symbol (₹) because standard PDF fonts can't encode it.
export function formatINRForPdf(amount) {
  const n = Math.round(amount) || 0;
  return `Rs ${n.toLocaleString("en-IN")}`;
}

export function formatDateDDMMYYYY(date) {
  const d = date instanceof Date ? date : new Date(date);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hours}:${minutes}`;
}

export function pad3(n) {
  return String(n).padStart(3, "0");
}

/**
 * Formats a phone number for display and creates a tel: link
 * @param {string} phone - The phone number to format
 * @returns {object} - { display: string, tel: string }
 */
export function formatPhoneNumber(phone) {
  if (!phone || phone === 'Not available') {
    return { display: 'N/A', tel: null };
  }
  
  // Remove all non-digit characters except + for tel link
  const telNumber = phone.replace(/[^\d+]/g, '');
  
  // Format for display - keep original format but ensure it's clean
  let display = phone.trim();
  
  // If phone doesn't start with +, ensure it's formatted for Indian numbers
  if (!telNumber.startsWith('+')) {
    // If it's a 10-digit number, format as +91 XXXXXXXXXX
    if (telNumber.length === 10) {
      display = `+91 ${telNumber.slice(0, 5)} ${telNumber.slice(5)}`;
      return { display, tel: `+91${telNumber}` };
    }
    // If it's 11 digits starting with 0, remove 0 and add +91
    if (telNumber.length === 11 && telNumber.startsWith('0')) {
      const withoutZero = telNumber.slice(1);
      display = `+91 ${withoutZero.slice(0, 5)} ${withoutZero.slice(5)}`;
      return { display, tel: `+91${withoutZero}` };
    }
  }
  
  return { display, tel: telNumber };
}

/**
 * Formats a phone number for Razorpay API
 * Razorpay requires format: +91XXXXXXXXXX (country code + 10 digits, no spaces)
 * @param {string} phone - The phone number to format
 * @returns {string} - Formatted phone number for Razorpay
 */
export function formatPhoneForRazorpay(phone) {
  if (!phone) {
    return "";
  }
  
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, "");
  
  // If already starts with country code (91), use as is
  if (digitsOnly.startsWith("91") && digitsOnly.length === 12) {
    return `+${digitsOnly}`;
  }
  
  // If starts with 0 followed by 10 digits, remove 0 and add 91
  if (digitsOnly.startsWith("0") && digitsOnly.length === 11) {
    return `+91${digitsOnly.slice(1)}`;
  }
  
  // If 10 digits, add 91
  if (digitsOnly.length === 10) {
    return `+91${digitsOnly}`;
  }
  
  // If already has +, return as is (assuming it's correct)
  if (phone.startsWith("+")) {
    // Remove spaces and ensure proper format
    const cleaned = phone.replace(/\s/g, "");
    return cleaned;
  }
  
  // Fallback: return with +91 if it looks like an Indian number
  if (digitsOnly.length >= 10) {
    const last10 = digitsOnly.slice(-10);
    return `+91${last10}`;
  }
  
  return phone; // Return original if can't format
}


